import Vue from 'vue'
import VueRouter from 'vue-router'
import fccBaseLoginRouter from 'pkgfe.fccbase/login'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('pkgfe.fccbase/baseLayout/fccHome.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  fccBaseLoginRouter.login,
  fccBaseLoginRouter.recuperarSenha,
  fccBaseLoginRouter.primeiroAcesso,
  fccBaseLoginRouter.cadastroExterno,
  fccBaseLoginRouter.questionario,
  {
    path: '/mensagens/tipo',
    name: 'Tipo de Mensagens',
    component: () => import('@/app/fccMensagens/fccMensagensTipo.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/mensagens',
    name: 'Mensagens',
    component: () => import('@/app/fccMensagens/fccMensagens.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/instrucoes',
    name: 'Instruções',
    component: () => import('@/app/fccInstrucoes/fccInstrucoes.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/seguranca/emuladores',
    name: 'emuladores',
    component: () => import('@/app/fccSeguranca/fccEmulados/fccEmuladores.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/seguranca/emuladores/:id?/:voltar?',
    name: 'emulados',
    component: () => import('@/app/fccSeguranca/fccEmulados/fccEmulados.vue'),
    meta: {
      isNeedAuth: true,
      originalPermission: '/seguranca/emulador'
    }
  },
  {
    path: '/seguranca/emulador',
    name: 'emulador',
    component: () => import('@/app/fccSeguranca/fccEmulados/fccEmuladosInternos.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/seguranca/aplicacoes',
    name: 'aplicacoes',
    component: () => import('@/app/fccSeguranca/fccAplicacoes.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/seguranca/permissao/acesso/:id?',
    name: 'permissao',
    component: () => import('@/app/fccSeguranca/fccPermissoes/fccPermissoes.vue'),
    meta: {
      originalPermission: '/seguranca/aplicacoes',
      isNeedAuth: true
    }
  },
  {
    path: '/seguranca/usuarios',
    name: 'usuarios',
    component: () => import('@/app/fccSeguranca/fccUsuarios.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/seguranca/usuarios-externos',
    name: 'usuarios-externos',
    component: () => import('@/app/fccSeguranca/fccUsuariosExternos.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/seguranca/aplicacoes/ordena',
    name: 'ordenamenu',
    component: () => import('@/app/fccSeguranca/fccMenuPrincipal.vue'),
    meta: {
      originalPermission: '/seguranca/aplicacoes',
      isNeedAuth: true
    }
  },
  {
    path: '/seguranca/grupos',
    name: 'gruposusuario',
    component: () => import('@/app/fccSeguranca/fccGrupos/fccGrupos.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/seguranca/logs',
    name: 'grupologs',
    component: () => import('@/app/fccSeguranca/fccLogs/fccLogs.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/seguranca/grupos/sub/:id?',
    name: 'subgrupos',
    component: () => import('@/app/fccSeguranca/fccGrupos/fccSubGrupos.vue'),
    meta: {
      originalPermission: '/seguranca/grupos',
      isNeedAuth: true
    }
  },
  {
    path: '/seguranca/objetos',
    name: 'objetosacao',
    component: () => import('@/app/fccSeguranca/fccObjetosAcao.vue'),
    meta: {
      originalPermission: '/seguranca/aplicacoes',
      isNeedAuth: true
    }
  },
  {
    path: '/seguranca/aplicacoes/objetos/:id?',
    name: 'objetos',
    component: () => import('@/app/fccSeguranca/fccObjetos.vue'),
    meta: {
      originalPermission: '/seguranca/aplicacoes',
      isNeedAuth: true
    }
  },
  {
    path: '/instrucoes/categorias',
    name: 'Categorias de Instruções',
    component: () => import('@/app/fccInstrucoes/fccInstrucoesCategorias.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/publicacoes/contasbancarias',
    name: 'Contas Bancárias',
    component: () =>
      import('@/app/fccPublicacoes/fccContasBancarias/fccPublicacoesContasBancarias.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/publicacoes/tipovisualizacao',
    name: 'Tipo Visualização',
    component: () => import('@/app/fccPublicacoes/fccPublicacoesTVisualizacao.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/publicacoes/tipogrupos',
    name: 'Tipo Grupo',
    component: () => import('@/app/fccPublicacoes/fccPublicacoesTGrupo.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/publicacoes/tipovisualizacao/:id?',
    name: 'Tipo Visualização por Id',
    component: () => import('@/app/fccPublicacoes/fccPublicacoesTVisualizacaoId.vue'),
    meta: {
      originalPermission: '/publicacoes/tipovisualizacao',
      isNeedAuth: true
    }
  },
  {
    path: '/publicacoes/tipo-conta-bancaria',
    name: 'Tipo de Pagamento',
    component: () => import('@/app/fccPublicacoes/fccContasBancarias/FccTipoContasBancarias.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/publicacoes/bancos',
    name: 'Cadastro de Bancos',
    component: () => import('@/app/fccPublicacoes/fccBancos/FccBancos.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/publicacoes',
    name: 'Listar Publicações',
    component: () => import('@/app/fccPublicacoes/fccPublicacoes.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/publicacoes/analise-fotos',
    name: 'Analise de fotos',
    component: () => import('@/app/fccPublicacoes/fccAnaliseFotos/fccAnaliseFotos.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/publicacoes/vagas-reservadas-padrao',
    name: 'Listar Vagas Reservadas',
    component: () =>
      import('@/app/fccPublicacoes/fccVagasReservadasPadrao/fccVagasReservadasPadrao.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/publicacoes/config',
    name: 'Tipos de Publicação',
    component: () => import('@/app/fccPublicacoes/fccPublicacoesConfig.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/publicacoes/historico',
    name: 'Histórico',
    component: () => import('@/app/fccPublicacoes/fccHistorico/fccHistorico.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/publicacoes/local-de-prova',
    name: 'Local de Prova',
    component: () => import('@/app/fccPublicacoes/fccLocalDeProva/fccLocalDeProva.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/sistema/configuracoes',
    name: 'Configurações',
    component: () => import('@/app/fccConfiguracoes/fccConfiguracoes.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/sistema/icones',
    name: 'Ícones',
    component: () => import('@/app/fccIcones/fccIcones.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/gestao-arquivos/repositorio/listar',
    name: 'Listar',
    component: () => import('@/app/fccGestaoArquivos/fccGestaoArquivosListar.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/gestao-arquivos/recuperacao',
    name: 'Recupera Arquivos',
    component: () => import('@/app/fccGestaoArquivos/fccGestaoRecuperacaoArquivos.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/gestao-arquivos/repositorio/parametros',
    name: 'Parametros',
    component: () => import('@/app/fccGestaoArquivos/fccGestaoArquivosParametros.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/gestao-arquivos/cadastro',
    name: 'Arquivos',
    component: () => import('@/app/fccGestaoArquivos/fccGestaoArquivosCadastro.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/gestao-arquivos/dashboard',
    name: 'Dashboard',
    component: () => import('@/app/fccGestaoArquivos/fccGestaoArquivosDashboard.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/gestao-arquivos/branding',
    name: 'Branding',
    component: () => import('@/app/fccGestaoArquivos/fccGestaoArquivosBranding.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/relatorios/cadastro',
    name: 'Relatórios',
    component: () => import('@/app/fccRelatorios/fccRelatoriosCadastro.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/relatorioperm/:id?',
    name: 'Relatórios Permissão',
    component: () => import('@/app/fccRelatorios/fccRelatoriosPermissao.vue'),
    meta: {
      originalPermission: '/relatorios/cadastro',
      isNeedAuth: true
    }
  },
  {
    path: '/relatorios/consulta',
    name: 'Relatórios Consulta',
    component: () => import('@/app/fccRelatorios/fccRelatoriosConsulta.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/relatorios/listar',
    name: 'Listar relatorio',
    component: () => import('@/app/fccRelatorios/fccListaRelatorios.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/gestao-cadastros/tipo-endereco',
    name: 'Tipo de Endereço',
    component: () => import('@/app/fccGestaoCadastros/fccGestaoCadastrosTipoEndereco.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/gestao-cadastros/tipo-contato',
    name: 'Tipo de Contato',
    component: () => import('@/app/fccGestaoCadastros/fccGestaoCadastrosTipoContato.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/gestao-cadastros/orgao-expedidor',
    name: 'Órgão Expedidor',
    component: () => import('@/app/fccPortalCandidato/gestaoCadastros/fccOrgaoExpedidor.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/publicacoes/banners',
    name: 'Cadastro Banners',
    component: () => import('@/app/fccPublicacoes/fccBanners/fccBannersCadastro.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/publicacoes/cadastro-funcoes',
    name: 'Cadastro Funções',
    component: () => import('@/app/fccPublicacoes/fccCadastroFuncoes/FccCadastroFuncoes.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/publicacoes/tipoapresentacao',
    name: 'Tipo Apresentação',
    component: () => import('@/app/fccPublicacoes/fccPublicacoesTApresentacao.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/publicacoes/parametrotipo',
    name: 'Tipo de Parâmetros',
    component: () => import('@/app/fccPublicacoes/fccPublicacaoParametroPadraoTipo.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/publicacoes/sir2/situacao',
    name: 'Situação Sir2',
    component: () => import('@/app/fccPublicacoes/fccSirs/fccSituacaoSir.vue'),
    meta: {
      originalPermission: '/publicacoes/tipovisualizacao',
      isNeedAuth: true
    }
  },
  {
    path: '/publicacoes/cadastro/tipo-arquivos',
    name: 'Tipo de arquivos',
    component: () => import('@/app/fccPublicacoes/fccTipoArquivos/fccTipoArquivos.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/publicacoes/sir2/tipo-envio/',
    name: 'Tipo de envio SIR2',
    component: () => import('@/app/fccPublicacoes/fccSirs/fccTipoEnvioSir2.vue'),
    meta: {
      originalPermission: '/publicacoes/tipovisualizacao',
      isNeedAuth: true
    }
  },
  {
    path: '/publicacoes/sir2/tipo/',
    name: 'Tipo SIR2',
    component: () => import('@/app/fccPublicacoes/fccSirs/fccTipoSir2.vue'),
    meta: {
      originalPermission: '/publicacoes/tipovisualizacao',
      isNeedAuth: true
    }
  },
  {
    path: '/publicacoes/sir2/sub-tipo/',
    name: 'Tipo de envio',
    component: () => import('@/app/fccPublicacoes/fccSirs/fccSubTipoSir2.vue'),
    meta: {
      originalPermission: '/publicacoes/tipovisualizacao',
      isNeedAuth: true
    }
  },
  {
    path: '/portal-candidato/cadastros/area-de-formacao',
    name: 'Área de formação',
    component: () => import('@/app/fccPortalCandidato/gestaoCadastros/fccAreaFormacao.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/portal-candidato/cadastros/escolaridade',
    name: 'Escolaridade',
    component: () => import('@/app/fccPortalCandidato/gestaoCadastros/fccEscolaridade.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/portal-candidato/cadastros/tipo-instituicao-escolar',
    name: 'Instituição Escolar',
    component: () => import('@/app/fccPortalCandidato/gestaoCadastros/fccInstituicao.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/portal-candidato/cadastros/instituicao-ensino-superior',
    name: 'Instituição Escolar Superior',
    component: () =>
      import('@/app/fccPortalCandidato/gestaoCadastros/fccInstituicaoEnsinoSuperior.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/portal-candidato/configuracoes',
    name: 'Configurações do portal',
    component: () => import('@/app/fccPortalCandidato/gestaoCadastros/fccConfiguracoes.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/portal-candidato/candidatos-deficiencia-auditiva',
    name: 'Candidato(s) com Deficiência Auditiva',
    component: () =>
      import('@/app/fccPortalCandidato/relatorios/fccCandidatoDeficienciaAuditiva.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/portal-candidato/cadastros/area-detalhada',
    name: 'Area Detalhada',
    component: () => import('@/app/fccPortalCandidato/gestaoCadastros/fccAreaDetalhada.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/portal-candidato/cadastros/area-especifica',
    name: 'Area Especifica',
    component: () => import('@/app/fccPortalCandidato/gestaoCadastros/fccAreaEspecifica.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/portal-candidato/cadastros/genero',
    name: 'Area Especifica',
    component: () => import('@/app/fccPortalCandidato/gestaoCadastros/fccGenero.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/portal-candidato/cadastros/curso-superior',
    name: 'Curso Superior',
    component: () => import('@/app/fccPortalCandidato/gestaoCadastros/fccCursoSuperior.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/portal-candidato/cadastros/sexo',
    name: 'Sexo',
    component: () => import('@/app/fccPortalCandidato/gestaoCadastros/fccSexo.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/portal-candidato/cadastros/estado-civil',
    name: 'Estado civil',
    component: () => import('@/app/fccPortalCandidato/gestaoCadastros/fccEstadoCivil.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/portal-candidato/cadastros/nacionalidade',
    name: 'Nacionalidade',
    component: () => import('@/app/fccPortalCandidato/gestaoCadastros/fccNacionalidade.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/portal-candidato/cadastros/etnia',
    name: 'Etnia',
    component: () => import('@/app/fccPortalCandidato/gestaoCadastros/fccEtnia.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/emails/template',
    name: 'Templates de e-mails',
    component: () => import('@/app/fccEmails/fccTemplatesEmail.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/emails/mensagens',
    name: 'Mensagens de e-mails',
    component: () => import('@/app/fccEmails/fccMensagensEmail.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/gerenciamento-filas/filas',
    name: 'Filas',
    component: () => import('@/app/fccGerenciamentoFilas/fccFilas.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/gerenciamento-filas/parametros',
    name: 'parametros',
    component: () => import('@/app/fccGerenciamentoFilas/fccParametros.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/gerenciamento-filas/agenda',
    name: 'Agenda',
    component: () => import('@/app/fccGerenciamentoFilas/fccAgenda.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/acompanhamento-projetos/listar',
    name: 'Listar Projetos',
    component: () => import('@/app/fccAcompanhamentoProjetos/fccListar/fccListar.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/acompanhamento-projetos/andamento-atividades',
    name: 'Andamento de Atividades',
    component: () =>
      import('@/app/fccAcompanhamentoProjetos/fccAndamentoAtividades/fccAndamentoAtividades.vue'),
    meta: {
      isNeedAuth: true
    }
  },
  {
    path: '/acompanhamento-projetos/adicionar-projeto',
    name: 'Adicionar projeto',
    component: () =>
      import('@/app/fccAcompanhamentoProjetos/fccAdicionarProjeto/fccAdicionarProjeto.vue'),
    meta: {
      isNeedAuth: true,
      originalPermission: '/acompanhamento-projetos/listar'
    }
  },
  {
    path: '/acompanhamento-projetos/editar-projeto/:id',
    name: 'Editar projeto',
    component: () =>
      import('@/app/fccAcompanhamentoProjetos/fccEditarProjeto/fccEditarProjeto.vue'),
    meta: {
      isNeedAuth: true,
      originalPermission: '/acompanhamento-projetos/listar'
    }
  },
  {
    path: '/acompanhamento-projetos/configuracoes',
    name: 'Configurações',
    component: () =>
      import('@/app/fccAcompanhamentoProjetos/fccConfiguracoes/fccConfiguracoes.vue'),
    meta: {
      isNeedAuth: true
    }
  }
]

const router = new VueRouter({
  routes,
  base: 'gestao_projetos/'
})

export default router

router.beforeEach(fccBaseLoginRouter.beforeEach)
